import React from "react";

const EventIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect width="28" height="28" fill="url(#pattern0_1373_1218)" />
    <defs>
      <pattern
        id="pattern0_1373_1218"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image0_1373_1218"
          transform="translate(-0.194444 -0.194444) scale(0.0138889)"
        />
      </pattern>
      <image
        id="image0_1373_1218"
        width="100"
        height="100"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export default EventIcon;
